import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { sidebarRouteConfig } from '../config/sidebarRoutes';

const ExploreSubNav: React.FC = () => {
    const location = useLocation();
    const pathname = location.pathname.replace(/\/$/, '') || '/';
    const config = sidebarRouteConfig[pathname];

    if (!config?.routes) return null;

    return (
        <div className="md:hidden relative flex gap-x-2 overflow-x-auto whitespace-nowrap pl-4 pr-0 py-3 scrollbar-hide bg-black/80">
            {config.routes.map((route) => (
                <NavLink
                    key={route.path}
                    to={route.path}
                    className={({ isActive }) =>
                        `transition-opacity duration-300 ${
                            isActive
                                ? 'text-white opacity-100'
                                : 'text-white opacity-50 hover:opacity-100'
                        }`
                    }
                >
                    {route.label}{route.path !== config.routes![config.routes!.length - 1].path ? ',' : ''}
                </NavLink>
            ))}
        </div>
    );
};

export default ExploreSubNav;
